import { ListImage, Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ViewProposalContainerStyled } from './style';
type Props = {
  specification?: string;
  numberOfExperience?: string;
  experience?: string;
  costEstimation?: string;
  qualification?: string;
  pastClient?: string[];
  pastProject?: string[];
};
const TechnicalSpecification = (props: Props) => {
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        TECHNICIAN SPECIFICATION
      </Typography>
      <VerticalSpaceStyled $space={30}>
        <InfoRowStyled $direction="column">
          <Typography className="title">Specification :</Typography>
          <Typography className="value">
            {props.specification || 'N/A'}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Experience :</Typography>
          <Typography className="value">{props.experience || 'N/A'}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Experience (in years) :</Typography>
          <Typography className="value">
            {props.numberOfExperience || ' 1 Year'} Year
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Cost Estimation :</Typography>
          <Typography className="value">
            €{props.costEstimation || 'N/A'}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography className="title">
              Reference of Past Project :
            </Typography>
            <ListImage
              imagesURL={props.pastProject?.map((logo, idx) => ({
                id: `${idx + 1}`,
                URL: logo,
              }))}
              imageHeight="100px"
              imageWidth="140px"
            />
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">
            Qualifications or Certifications :
          </Typography>
          <Typography className="value">
            {props.qualification || 'N/A'}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Past Clients :</Typography>
          {props.pastClient?.map((pClient, index) => (
            <Typography className="value" key={pClient}>
              {index + 1}. {pClient || 'None'}
            </Typography>
          ))}
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default TechnicalSpecification;
